import { Component, Input } from '@angular/core';

@Component({
	selector: 'custom-tag',
	templateUrl: './custom-tag.component.html',
	styleUrls: ['./custom-tag.component.scss'],
})
export class CustomTagComponent {
	@Input()
	public label: string;

	@Input()
	public icon?: string;
}
